module.exports = __webpack_public_path__ + "assets/integration.b6367eaf.svg";